import { Controller } from "@hotwired/stimulus";
import { Collapse } from "bootstrap";

export default class extends Controller {
  connect() {
    if (this.hasSelectedInfoOptions()) {
      Collapse.getOrCreateInstance(this.infoElement()).show();
    }
  }

  handleChange() {
    const collapse = Collapse.getOrCreateInstance(this.infoElement());
    this.hasSelectedInfoOptions() ? collapse.show() : collapse.hide();
  }

  hasSelectedInfoOptions() {
    return Array.from(
      this.element.querySelectorAll('option[data-info-targets="toon"]'),
    ).some((elem) => elem.selected);
  }

  infoElement() {
    return document.getElementById("doelgroepen-informatie");
  }
}
